/**
 * 머리말 메뉴 모델(marketing-site-shell) — 순서가 곧 화면 순서다. 「서비스」 는 패널을 여는 버튼이라 따로 둔다.
 * `pageKey` 는 지금 페이지 표시(`aria-current="page"`)에 쓰고, 문구는 `landing:site.nav.<labelKey>` 다.
 */
export type SitePageKey =
  | "landing"
  | "accurate"
  | "survey"
  | "plan"
  | "inquiry"
  | "news"
  | "manual"
  | "releases"
  | "privacy";

export const SITE_PAGE_KEY_BY_ROUTE: Readonly<Record<string, SitePageKey>> = {
  "/": "landing",
  "/accurate": "accurate",
  "/survey": "survey",
  "/plan": "plan",
  "/inquiry": "inquiry",
  "/news": "news",
  "/news/[id]": "news",
  "/manual": "manual",
  "/releases": "releases",
  "/privacy": "privacy",
};

export const SITE_SERVICE_LINKS = [
  {
    pageKey: "accurate",
    href: "/accurate",
    labelKey: "platform",
    art: "art/tile_platform.svg",
  },
  {
    pageKey: "survey",
    href: "/survey",
    labelKey: "survey",
    art: "art/tile_survey.svg",
  },
] as const;

export const SITE_NAV_LINKS = [
  { pageKey: "plan", href: "/plan", labelKey: "plans" },
  { pageKey: "inquiry", href: "/inquiry", labelKey: "inquiry" },
  { pageKey: "news", href: "/news", labelKey: "news" },
  { pageKey: "manual", href: "/manual", labelKey: "manual" },
  { pageKey: "releases", href: "/releases", labelKey: "releases" },
] as const;

export const SITE_APP_START_HREF = "/projects-list";
